import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PLayout from "./PLayout";
import { useApp } from "@/context/AppContext";
import { useAppUi } from "@/i18n/appUi";
import { myProgram } from "@/lib/api";

const SESSION_RE = /(?:session|sessie|\u0441\u0435\u0441\u0438\u044f|\u0441\u0435\u0441\u0456\u044f|\u0441\u0435\u0441\u0441\u0438\u044f)\s*0?([1-6])/i;
const sessionNum = (title) => {
  const m = title && title.match(SESSION_RE);
  return m ? parseInt(m[1], 10) : null;
};

function Day({ day, index, t }) {
  const n = sessionNum(day.title);
  const inner = (
    <>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 12, alignItems: "center" }}>
        <strong>{day.title || `${t("dayLabel")} ${index + 1}`}</strong>
        <span className="rbl-badge muted">{day.date}</span>
      </div>
      {day.agenda && <div style={{ color: "var(--muted)", fontSize: 14, marginTop: 6, whiteSpace: "pre-wrap" }}>{day.agenda}</div>}
      {n && <div className="rbl-card-cta" style={{ marginTop: 10 }}>{t("pgOpen")} {String(n).padStart(2, "0")} →</div>}
    </>
  );
  if (n) {
    return <Link to={`/session/${n}`} className="rbl-list-item" style={{ display: "block" }} data-testid={`program-day-${index}`}>{inner}</Link>;
  }
  return <div className="rbl-list-item" style={{ display: "block" }} data-testid={`program-day-${index}`}>{inner}</div>;
}

export default function Program() {
  const { lang } = useApp();
  const t = useAppUi(lang);
  const [data, setData] = useState(null);
  useEffect(() => { myProgram().then(setData).catch(() => setData({ programs: [], groups: [] })); }, []);

  if (!data) return <PLayout><div className="rbl-spinner" /></PLayout>;
  const group = data.groups[0];

  return (
    <PLayout>
      <h1 className="rbl-h1" style={{ fontSize: 36 }}>🎓 {t("pgTitle")}</h1>
      {group && (
        <div className="rbl-feature" style={{ marginTop: 12 }} data-testid="program-group">
          <h3>{group.name}</h3>
          <p>{group.company} · {group.training_program || group.topic}</p>
        </div>
      )}
      {data.programs.length === 0 && <p style={{ color: "var(--muted)", marginTop: 20 }}>{t("pgNone")}</p>}
      {data.programs.map((p) => (
        <div key={p.id} style={{ marginTop: 24 }} data-testid={`program-${p.id}`}>
          <h2 className="rbl-block-h">{p.title}</h2>
          {p.description && <p className="rbl-prose"><span style={{ whiteSpace: "pre-wrap" }}>{p.description}</span></p>}
          <p style={{ color: "var(--muted)", fontSize: 14 }}>{t("pgTip")}</p>
          <div style={{ marginTop: 12 }}>
            {(p.days || []).map((d, i) => <Day key={d.id || i} day={d} index={i} t={t} />)}
          </div>
        </div>
      ))}
    </PLayout>
  );
}
